/* eslint-disable import/prefer-default-export */
import * as events from '../events';
import genericEvents from './generic-events';

export const FlowModule = {
    name: 'External MTN NG',
    logger: {},
    dispatcher: {},
    uiControl: {},
    tracker: {},
    integrator: {},
    productUrl: '',
    locale: '',
    identity: '',
    productSlug: '',
    plan: '',
    metadata:{},
    fraudDetection: '',
    integratorResponseCode: 200,
    step: '',

    /**
     * Method to initialise the flow. This will be binding all the event listeners
     * needed to implement the external flow
     */
    init() {
        this.initNewFlow();
    },

    initNewFlow() {
        this.logger.debug(`Flow (${this.name}): initialising flow`);
        this.bindClickEvents();

        if (this.integratorResponseCode === 200) {
            this.logger.debug(`Flow (${this.name}): display first button`);
            this.uiControl.showElement(this.uiControl.controls.external);
            this.tracker.track(events.SHOWN_LANDING_PAGE);
        } else {
            this.logger.error(`Flow (${this.name}): Integrator error.`, this.integratorResponseCode);
            this.uiControl.showErrorMessage('INTEGRATOR_ERROR');
            this.tracker.track(events.INTEGRATOR_ERROR);
        }
    },

    /**
     * Binding the click events on the button (#flow-subscribe)
     */
    bindClickEvents() {
        this.logger.debug(`Flow (${this.name}): binding click events`);
        genericEvents.bindFlowExitEvent(this);

        this.dispatcher.addEventListener(events.FIRST_CLICK, () => {
            this.logger.debug(`Flow (${this.name}): handling button click - go to LP`);
            this.tracker.track(events.FIRST_CLICK);
            this.uiControl.hideElement(this.uiControl.controls.external);
            this.uiControl.showElement(this.uiControl.controls.spinner);
            this.redirectToLandingPage()
        });
    },

    /**
     * Binding the tracking events
     */
    bindTrackingEvents() {
        this.dispatcher.addEventListener(events.EXIT_CLICK, (event) => {
            this.tracker.track(events.EXIT_CLICK, {
                data: {
                    reference: event.reference,
                },
            });
        });
    },

    /**
     * Redirect to product with an auth token
     */
    redirectToLandingPage() {
        // remove unload message
        window.onbeforeunload = null;

        this.tracker.track(events.REDIRECT_TO_LANDING_PAGE);

        const capturePageUrl = this.integrator.baseUrl;
        const gclid = this.metadata.gclid;
        const ts = this.metadata.ts;
        const eventTrackingId = this.metadata.event_tracking_id

        const redirectUrl = `${capturePageUrl}/capture?plan_id=${this.plan}&product_slug=${this.productSlug}&gclid=${gclid}&ts=${ts}&event_tracking_id=${eventTrackingId}`;

        this.logger.debug(`Flow (${this.name}): redirecting to capture page`, redirectUrl);

        window.location.assign(redirectUrl);
    },

};

window.FlowModule = FlowModule;
